import { Component, inject, OnInit, signal, ChangeDetectionStrategy } from '@angular/core';

import { MetaService } from '@web/csl-lib-services';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-admin-site-footer',
  standalone: true,
  imports: [],
  templateUrl: './admin-site-footer.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './admin-site-footer.component.css',
})
export class AdminSiteFooterComponent implements OnInit {
  protected year: number = new Date().getFullYear();
  protected version: string = environment.version;
  protected apiVersion = signal('');
  protected dbVersion = signal('');
  readonly metaService: MetaService;

  constructor() {
    this.metaService = inject(MetaService);
  }

  ngOnInit() {

    this.metaService.getApiVersion().subscribe((apiVersion: string) => {
      this.apiVersion.set(apiVersion);
    });

    this.metaService.getDbVersion().subscribe((dbVersion: string) => {
      this.dbVersion.set(dbVersion);
    });
  }
}
